module.exports = __webpack_public_path__ + "static/media/057-woman-14.042f9d4c.svg";